/**
 * Workspace pending actions from GET /accounts/{id}/pending-actions.
 * Extend PENDING_ACTION_TYPES, PENDING_ACTION_ROUTE_BY_TYPE, priority, and skip rules when adding types.
 */

import Cookies from "js-cookie"

// Cookie de "preencher depois": guarda por 24h que o usuário optou por adiar a
// ação, para não ficar redirecionando sempre para a tela da pending action.
const PENDING_ACTION_SKIP_COOKIE_PREFIX = "pending_action_skip"
const PENDING_ACTION_SKIP_EXPIRES_DAYS = 1 // 1 dia = 24 horas

export function getPendingActionSkipCookieName(type, accountId) {
  return `${PENDING_ACTION_SKIP_COOKIE_PREFIX}_${type}_${accountId}`
}

/** Marca a pending action como "preencher depois" por 24 horas. */
export function skipPendingAction(type, accountId) {
  if (!type || !accountId) {
    return
  }
  Cookies.set(getPendingActionSkipCookieName(type, accountId), "1", {
    expires: PENDING_ACTION_SKIP_EXPIRES_DAYS,
  })
}

/** Indica se a pending action foi adiada (cookie ainda válido). */
export function isPendingActionSkipped(type, accountId) {
  if (!type || !accountId) {
    return false
  }
  return Cookies.get(getPendingActionSkipCookieName(type, accountId)) === "1"
}

export const PENDING_ACTION_TYPES = Object.freeze({
  MISSING_BILLING_PROFILE: "missing_billing_profile",
  // SELECT_BILLING_PLAN: "select_billing_plan",
  // CREDITS_DEPLETED: "credits_depleted",
  // CREDITS_LOW: "credits_low",
})

const PENDING_ACTION_ROUTE_BY_TYPE = {
  [PENDING_ACTION_TYPES.MISSING_BILLING_PROFILE]: "/dashboard/workspace/billing/account-identification",
  // [PENDING_ACTION_TYPES.SELECT_BILLING_PLAN]: "/plans",
}

const PENDING_ACTION_PRIORITY = [
  PENDING_ACTION_TYPES.MISSING_BILLING_PROFILE,
  // PENDING_ACTION_TYPES.SELECT_BILLING_PLAN,
]

/**
 * Dashboard (or billing) paths where we should not force redirect to pending-action screens.
 */
export function shouldSkipPendingActionsRedirect(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return false
  }
  if (pathname === "/dashboard/account/connected-apps" || pathname.startsWith("/dashboard/integrations")) {
    return true
  }
  if (pathname === "/plans" || pathname.startsWith("/plans/")) {
    return true
  }
  if (pathname.includes("/workspace/billing/changeplan")) {
    return true
  }
  if (pathname.includes("/workspace/billing/account-identification")) {
    return true
  }
  return false
}

/**
 * @param {Array<{ type: string, id?: string }>} actions
 * @param {string} [accountId] usado para respeitar o cookie "preencher depois"
 * @returns {{ path: string, action: { type: string, id: string } } | null}
 */
export function getPendingRedirectWithAction(actions, accountId) {
  if (!Array.isArray(actions)) {
    return null
  }

  for (const type of PENDING_ACTION_PRIORITY) {
    if (isPendingActionSkipped(type, accountId)) {
      continue
    }
    const action = actions.find((item) => item?.type === type && item?.id)
    const path = PENDING_ACTION_ROUTE_BY_TYPE[type]
    if (action && path) {
      return { path, action }
    }
  }

  return null
}

/**
 * @param {Array<{ type: string }>} actions
 * @param {string} [accountId]
 * @returns {string | null} first matching redirect path, or null
 */
export function getRedirectForPendingActions(actions, accountId) {
  const found = getPendingRedirectWithAction(actions, accountId)
  return found?.path ?? null
}
